<template>
  <v-container fluid>
    <v-toolbar flat class="mb-3">
      <v-toolbar-title>Envios Realizados</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <div v-if="loader">
        <v-skeleton-loader class="mx-auto" type="table"></v-skeleton-loader>
      </div>
      <div v-else>
        <v-data-table :headers="headers" :items="envios" :search="search">
            <template v-slot:item.acciones="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="consultarDetalle(item)"
              >
               mdi-arrow-expand-all
              </v-icon>
            </template>
        </v-data-table>
      </div>
    </v-card>
    <v-card>
      <v-row>
        <v-col cols="12" sm="10" md="10">
          <v-tabs show-arrows v-model="mes_selecionado">
            <v-tab
              v-for="detalle in mes"
              @click="consultarEnvios"
              :key="detalle.id"
            >
              {{ detalle.mes }}
            </v-tab>
          </v-tabs>
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <v-select
            class=""
            v-model="anio_selecionado"
            :items="anios_servicios"
            label="Años"
            solo
          ></v-select>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Información de Envio</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list
          three-line
          subheader
        >
          <v-subheader>Datos Generales</v-subheader>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Fecha de Envio</v-list-item-title>
              <v-list-item-subtitle>{{envio_selecionado.fecha}}    {{envio_selecionado.hora}}</v-list-item-subtitle>
            </v-list-item-content>
               <v-list-item-content>
              <v-list-item-title>Cantidad de Folios</v-list-item-title>
              <v-list-item-subtitle>{{detalles.length}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
           <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Remitente</v-list-item-title>
              <v-list-item-subtitle>{{envio_selecionado.nombre_remitente}} </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title>Dirección Origen</v-list-item-title>
              <v-list-item-subtitle>{{envio_selecionado.direccion_remitente}}  </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title>Datos de Contacto</v-list-item-title>
              <v-list-item-subtitle>{{envio_selecionado.telefono_remitente}} </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Destintario</v-list-item-title>
              <v-list-item-subtitle>{{envio_selecionado.nombre_destintario}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title>Dirección Destino</v-list-item-title>
              <v-list-item-subtitle>{{envio_selecionado.direccion_destino}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title>Datos de Contacto</v-list-item-title>
              <v-list-item-subtitle>{{envio_selecionado.telefono_destintario}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
         <v-subheader>Folios Generados</v-subheader>
         <v-data-table
              dense
              :headers="headers_detalle"
              :items="detalles"
              class="elevation-1"
            ></v-data-table>
      </v-card>
    </v-dialog>
      <v-dialog
      v-model="dialog_mensaje_correcto"
      max-width="350"
    >
      <v-card>

        <v-card-text>
           <pdf :src="url" ref="pdf"></pdf>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="$refs.pdf.print()"
          >
            Imprimir
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="dialog_mensaje_correcto = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import pdf from "vue-pdf";
import service from "@/core/Servicio.js";
export default {
    components: {
    pdf
  },
  data: () => ({
    search: "",
    loader: false,
    dialog:false,
    mes_selecionado: null,
    anio_selecionado: null,
    estatus_selecionado: null,
    envio_selecionado :{
      id_envio:null,
      fecha : null  ,
      hora : null ,
      nombre_documento : null  ,
      nombre_remitente : null  ,
      numero_remitente : null  ,
      calle_remitente : null ,
      telefono_remitente : null,
      numero_int_remitente : null,
      codigo_remitente : null,
      colonia_remitente : null,
      nombre_destintario : null,
      numero_destintario : null,
      calle_destintario : null,
      telefono_destintario : null,
      entre_calles : null,
      numero_int_destintario : null,
      codigo_destintario : null,
      colonia_destintario : null,
      direccion_destino : null,
      direccion_remitente : null
    },
    mes: [
      { id: 0, mes: "Ene" },
      { id: 1, mes: "Feb" },
      { id: 2, mes: "Mar" },
      { id: 3, mes: "Abr" },
      { id: 4, mes: "May" },
      { id: 5, mes: "Jun" },
      { id: 6, mes: "Jul" },
      { id: 7, mes: "Ago" },
      { id: 8, mes: "Sep" },
      { id: 9, mes: "Oct" },
      { id: 10, mes: "Nov" },
      { id: 11, mes: "Dic" },
    ],
    anios_servicios: [2021, 2020, 2019],
    headers: [
      {
        text: "Fecha",
        align: "start",
        value: "fecha",
      },
      { text: "Horario", value: "hora" },
      { text: "Destintario", value: "nombre_destintario" },
      { text: "Remitente", value: "nombre_remitente" },
      { text: "Destino", value: "direccion_destino" },
      { text: "Acciones", value: "acciones", filterable: false },
    ],
    headers_detalle: [
      {
        text: "Folio",
        align: "start",
        value: "folio",
      }
    ],
    estatus: [
      { 
        id: 1,
        estatus: "REALIZADAS",
      }
    ],
    envios: [],
    detalles: [],
    dialogDelete: false,
    dialog_mensaje_correcto:false,
    editedItem: null,
    editedIndex: null,
    url:""
  }),
  created() {
    const fecha = new Date();
    this.anio_selecionado = fecha.getFullYear();
    this.mes_selecionado =  fecha.getMonth();
    this.consultarEnvios();
  },
  methods: {
    consultarDetalle(item){
      this.dialog = true;
      this.envio_selecionado = item;
       let params = {
        "id": this.envio_selecionado.id_envio,
      }
      service
        .consultarDetalles(params)
        .then((result) => {
          this.detalles = result.data.response;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    imprimirDetalle(item){
      this.url = process.env +item.nombre_documento;
      window.open(this.url, 'Download');  
    },
    consultarEnvios() {
      this.loader = true;
      let params = {
        "cliente_id":localStorage.getItem("id"),
        "mes" : this.mes_selecionado  + 1,
        "anio" : this.anio_selecionado
      }
      service
        .consultarEnvios(params)
        .then((result) => {
          this.loader = false;
          this.envios = result.data.response;
        })
        .catch((err) => {
          this.loader = false;
          console.log(err);
        });
    },
  },
};
</script>
